import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccentureValidatorsMessageComponent } from './accenture-validators-message/accenture-validators-message.component';

@NgModule({
  imports: [CommonModule],
  declarations: [AccentureValidatorsMessageComponent],
  exports: [AccentureValidatorsMessageComponent],
})
export class AccentureValidatorsModule {}
